import { clientId } from "./constants";
import "./propertyRenderers";
import "./appLinks";

export const ticketManagementRoutes = [
  {
    path: "/maintenance",
    name: "tmMyTickets",
    props: true,
    component: () => import("@shared/maintenance/views/MyTickets.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "tmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/maintenance-admin",
    name: "tmTicketsAdmin",
    props: true,
    component: () => import("@shared/maintenance/views/TicketAdmin.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "ticketAdmin",
          route: { name: "tmTicketsAdmin" },
        },
      ],
    },
  },
  {
    path: "/maintenance-search",
    name: "tmTicketsSearch",
    props: true,
    component: () => import("@shared/maintenance/views/TicketSearch.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "ticketSearch",
          route: { name: "tmTicketsSearch" },
        },
      ],
    },
  },
  {
    path: "/maintenance/create",
    name: "tmCreateTicket",
    props: true,
    component: () =>
      import("@shared/maintenance/views/CreateMaintenanceTicket.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "tmMyTickets" },
        },
        {
          label: "createTicket",
          route: { name: "tmCreateTicket" },
        },
      ],
    },
  },
  {
    path: "/maintenance/ticket/:id",
    name: "tmTicketDetail",
    props: true,
    component: () => import("@shared/maintenance/views/TicketDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "tmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/maintenance/access",
    name: "tmAccess",
    props: true,
    component: () => import("@shared/maintenance/views/MaintenanceAccess.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "accessRights",
          route: { name: "tmAccess" },
        },
      ],
    },
  },

  {
    path: "/maintenance/plans",
    name: "tmMaintenancePlans",
    component: () =>
      import("@shared/maintenance/views/MaintenancePlanList.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "maintenancePlans",
          route: { name: "tmMaintenancePlans" },
        },
      ],
    },
  },

  {
    path: "/maintenance/calendar",
    name: "tmMaintenanceCalendar",
    component: () => import("@shared/maintenance/views/TicketCalendar.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "calendar",
          route: { name: "tmMaintenanceCalendar" },
        },
      ],
    },
  },

  {
    path: "/maintenance/plans/edit/:id?",
    name: "tmMaintenancePlansEdit",
    props: true,
    component: () =>
      import("@shared/maintenance/views/MaintenancePlanCreateUpdate.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "maintenancePlans",
          route: { name: "tmMaintenancePlans" },
        },
      ],
    },
  },

  {
    path: "/maintenance/sop",
    name: "tmSop",
    props: true,
    component: () => import("@shared/maintenance/views/SopManagement.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sopManagement",
          route: { name: "tmSop" },
        },
      ],
    },
  },
  {
    path: "/maintenance/sop/:id",
    name: "tmSopDetail",
    props: true,
    component: () => import("@shared/maintenance/views/SopVersions.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sopManagement",
          route: { name: "tmSop" },
        },
      ],
    },
  },
  {
    path: "/maintenance/sop/:id/edit",
    name: "tmSopEdit",
    props: true,
    component: () => import("@shared/maintenance/views/SopEdit.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sopManagement",
          route: { name: "tmSop" },
        },
      ],
    },
  },
  {
    path: "/maintenance/machine-restrictions",
    name: "tmMachineRestrictions",
    component: () =>
      import("@shared/maintenance/views/MachineRestrictionOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "machineRestrictions",
          route: { name: "tmMachineRestrictions" },
        },
      ],
    },
  },
  {
    path: "/maintenance/machine-restrictions/edit/:templateId/:id?",
    name: "tmMachineRestrictionsCreateEdit",
    component: () =>
      import("@shared/maintenance/views/MachineRestrictionDetailView.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "machineRestrictions",
          route: { name: "tmMachineRestrictions" },
        },
      ],
    },
  },
  {
    path: "/maintenance/ticket-history/:id",
    name: "ticketHistory",
    component: () =>
      import("@shared/maintenance/views/MaintenanceTicketHistory.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "tmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/maintenance/reports",
    name: "tmReports",
    component: () => import("@shared/maintenance/views/Reports.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "tmReports" },
        },
      ],
    },
  },
  {
    path: "/maintenance/reports-machine",
    name: "tmMachineReports",
    component: () => import("@shared/maintenance/views/ReportsMachine.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "tmReports" },
        },
      ],
    },
  },
  {
    path: "/maintenance/reports-overview",
    name: "tmReportsOverview",
    component: () =>
      import("@shared/maintenance/views/MaintenanceReportsOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "tmReportsOverview" },
        },
      ],
    },
  },
  {
    path: "/maintenance/reports/custom/:groupId",
    name: "tmCustomReport",
    props: true,
    component: () =>
      import("@shared/maintenance/views/MaintenanceCustomReport.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "tmReportsOverview" },
        },
      ],
    },
  },
  {
    path: "/maintenance/dashboard",
    name: "tmDashboardList",
    component: () =>
      import("@shared/maintenance/views/MaintenanceDashboardList.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboards",
          route: { name: "tmDashboardList" },
        },
      ],
    },
  },
  {
    path: "/maintenance/dashboard/:dashboardId",
    name: "tmDashboardDetail",
    props: true,
    component: () =>
      import("@shared/maintenance/views/MaintenanceDashboardDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboards",
          route: { name: "tmDashboardList" },
        },
      ],
    },
  },
];
